import React from 'react';

import { CustomerCard } from 'Jsx/CheckoutV4/types';

import SavedCardItem from './SavedCardItem';

type SelectProp = {
  getSelectedCard: (selectedCard: CustomerCard) => void;
  savedCards: CustomerCard[];
};
const SavedCardsList: React.FC<SelectProp> = ({
  getSelectedCard,
  savedCards,
}) => {
  const [selectedCardIndex, setSelectedCardIndex] = React.useState(0);

  React.useEffect(() => {
    const defaultSavedCard =
      savedCards?.find(card => card?.defaultCard) || savedCards[0];

    if (defaultSavedCard) {
      getSelectedCard(defaultSavedCard);
    }
  }, [savedCards]);

  const onChangeCard = (card: CustomerCard) => {
    getSelectedCard(card);
  };

  return (
    <div>
      {savedCards?.map((card, index) => (
        <SavedCardItem
          key={index.toString()}
          card={card}
          isSelected={index === selectedCardIndex}
          handleSelectSavedCard={() => {
            setSelectedCardIndex(index);
            onChangeCard(card);
          }}
        />
      ))}
    </div>
  );
};

export default SavedCardsList;
